import React from "react";
import { no_img } from "../../../../assets";

const ProdWidget = ({ imgUrl, label, subtitle }) => {
  return (
    <div className="flex gap-[15px] items-center mb-[5px] mt-[5px] mr-[30px]">
      <img
        src={imgUrl ? imgUrl : no_img}
        alt="product_img"
        className="img-fluid bg-white rounded-[10px] shadow-md  w-[60px] h-[40px] object-contain"
      />
      <div className="grid">
        <span className="">{label}</span>
        <span className="text-[12px]">{subtitle}</span>
      </div>
    </div>
  );
};

export default ProdWidget;
